var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26758 6.75C6.26758 7.78553 7.10704 8.625 8.14258 8.625C9.17811 8.625 10.0176 7.78553 10.0176 6.75C10.0176 5.71447 9.17811 4.875 8.14258 4.875C7.10704 4.875 6.26758 5.71447 6.26758 6.75Z",
    fill: "#36C4A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14258 0C1.93344 0 0.142578 1.79086 0.142578 4V12C0.142578 14.2091 1.93344 16 4.14258 16H12.1426C14.3517 16 16.1426 14.2091 16.1426 12V4C16.1426 1.79086 14.3517 0 12.1426 0H4.14258ZM11.8926 6.75C11.8926 9.44607 8.14258 13 8.14258 13C8.14258 13 4.39258 9.44607 4.39258 6.75C4.39258 4.67893 6.07151 3 8.14258 3C10.2136 3 11.8926 4.67893 11.8926 6.75Z",
    fill: "#36C4A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cd2d152436c59c8912b4a7229f4cdec0.svg";
export { ForwardRef as ReactComponent };